module.exports = __webpack_public_path__ + "static/img/case-1hanshiqiao.e4f48b77.jpg";